import addGoogleMap from '../../scripts/app/google-map';
import addGoogleMapFacilities from '../../scripts/app/google-map-facilities';

// Facilities map

addGoogleMapFacilities('.jsFacilitiesMap');

// Central map

addGoogleMap('.jsCentralMap');

// Facility map

addGoogleMap('.jsFacilityMap');
